import { Injectable } from '@angular/core';
import { IPaetepCfGenericMapperService } from '../../interfaces/paetep-cf-generic-mapper.service';
import { RubricAnswerConfig } from 'src/app/model/observation/custom-forms/answer-configs/rubric-answer-config.model';
import { EdlCfAnswerRubricModel, EdlCfGenericModel, EdlCfRubricModel, MAX_DESCRIPTION_LENGTH, MAX_OPTION_LABEL_LENGTH, MAX_TITLE_LENGTH } from '@edl-development/edl-custom-forms';
import { CustomFormQuestionDisplayDTO } from 'src/app/model/observation/custom-forms/custom-form-question-dto.model';
import { EdlProficiencyPickerOptions } from '@edl-development/edl-common';
import { CustomFormQuestionType } from 'src/app/model/enum/observations/custom-forms/custom-form-question-type.enum';
import { RatingSubAnswerConfig } from 'src/app/model/observation/custom-forms/answer-configs/sub-answer-configs/rating-sub-answer-config.model';
import { CustomFormsHelpersService } from '../../custom-forms-helpers/custom-forms-helpers.service';

@Injectable({
    providedIn: 'root'
})
export class PaetepCfRubricMapperService implements IPaetepCfGenericMapperService<RubricAnswerConfig, EdlCfRubricModel, string, EdlCfAnswerRubricModel | null> {

    constructor(private customFormsHelpersService: CustomFormsHelpersService) { }

    public toEdlModel = (child: CustomFormQuestionDisplayDTO<RubricAnswerConfig>): EdlCfRubricModel=> {
        const options: EdlProficiencyPickerOptions[] = child.answerConfig?.ratings?.map((r) => {
            return {
                Title: r.ratingLabel,
                Description: r.ratingDesc,
                Value: Number(r.ratingValue),
                HexColor: this.convertRGBToHexColor(r.ratingColor)
            }
        }) ?? []

        return {
            title: child.label,
            isRequired: child.required,
            options
        }
    }

    private convertRGBToHexColor(rgb: string = ''): string {
        if (!rgb.startsWith('rgb')) return rgb;

        return rgb.replace(/[^\d,]/g,'')
                .split(',')
                .map(Number)
                .map(n => n.toString(16).padStart(2, '0'))
                .reduce((acc, val) => acc + val, '#');
    }

    public toPaetepModel = ({
        formID, 
        sectionID,
        displayOrder,
        groupOrder,
        question
    } : {
        formID: string, 
        sectionID: string, 
        displayOrder: number,
        groupOrder: number,
        question: EdlCfGenericModel<EdlCfRubricModel>
    }): CustomFormQuestionDisplayDTO<RubricAnswerConfig> =>  {
        const ratings: RatingSubAnswerConfig[] = question.config.options.map(o => {
            return {
                ratingValue: `${o.Value}`,
                ratingLabel: (o.Title ?? '').substring(0, MAX_OPTION_LABEL_LENGTH),
                ratingDesc: (o.Description ?? '').substring(0, MAX_DESCRIPTION_LENGTH),
                ratingColor: o.HexColor
            }
        });;

        return this.customFormsHelpersService.createCustomFormQuestion<RubricAnswerConfig>({
            $type: CustomFormQuestionType.RUBRIC,
            typeID: CustomFormQuestionType.RUBRIC,
            formID,
            sectionID,
            questionID: question.id,
            readOnly: false,
            required: question.config.isRequired,
            displayOrder,
            groupOrder,
            label: (question.config.title ?? '').substring(0, MAX_TITLE_LENGTH),
            displayLabel: true,
            answerConfig: {
                ratings
            }
        });
    }

    public toEdlAnswer = (answer: string = '', question: CustomFormQuestionDisplayDTO<RubricAnswerConfig>) => {
        const value = Number(answer);

        return isNaN(value) ? null : value;
    }

}
